import { axios } from "../utils/axios";

// Unauthenticated calls from the hortihub.in landing page.
export const requestAccess = (body) => axios.post(`${process.env.REACT_APP_API_HOST}/api/public/access-requests`, body);
